export default "8ec8b113579725239abc74ed02266de4.png";